class SpaceElement extends HTMLElement {
  constructor() {
    super();

    this.floorPlan = this.querySelector('aside.floor-plan');
    this.setHeight();

    this.areas = this.querySelectorAll('area-element');
    this.areas.forEach(a => a.addEventListener('click', this.areaClickHandler.bind(this)));

    this.detailsPane = this.querySelector('main');
    this.areaDetailsPanes = this.querySelectorAll('.area-details');

    this.toFloorPlanButton = this.querySelector('main button.to-floor-plan');
    this.toFloorPlanButton.addEventListener('click', this.scrollToFloorPlan.bind(this));
  }

  areaClickHandler(evt) {
    const tabIndex = evt.currentTarget.tabIndex;
    const detailsPane = this.querySelector(`.area-details[tabindex="${tabIndex}"]`);

    if(evt.currentTarget.classList.contains('active'))
      return

    this.areaDetailsPanes.forEach(p => p.classList.remove('active'));
    detailsPane.classList.add('active');

    this.areas.forEach(a => a.classList.remove('active'));
    evt.currentTarget.classList.add('active');
  }

  scrollToFloorPlan() {
    this.parentElement.scrollIntoView();
  }

  calculateHeight(element, setMaxHeight = false) {
    const distanceFromTop = Utils.getDistanceFromTop(element);
    return window.innerHeight - distanceFromTop;
  }

  setHeight() {    
    this.floorPlan.style.height = this.calculateHeight(this.floorPlan) + 'px';
    this.floorPlan.style.maxHeight = this.calculateHeight(this.floorPlan, true) + 'px';
  }
}

class Arealement extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('.area-content');
    this.closeButton = this.querySelector('button.close');
    this.toggleTextButton = this.querySelector('button.toggle-text');
    this.toBookingsButton = this.querySelector('button.to-bookings');

    this.toggleTextButton.addEventListener('click', this.toggleText.bind(this));
    this.closeButton.addEventListener('click', this.closeArea.bind(this));

    if(this.toBookingsButton)
      this.toBookingsButton.addEventListener('click', this.scrollToBookings.bind(this));

    this.areaDetailsPanes = document.querySelectorAll('.area-details');
  }

  toggleText(evt) {
    this.content.classList.toggle('content-hidden');
    evt.currentTarget.classList.toggle('content-hidden');
  }

  scrollToBookings(evt) {
    const bookingsPane = document.querySelector(`.area-details[tabindex="${this.tabIndex}"]`);

    bookingsPane.scrollIntoView();
  }

  closeArea(evt) {
    evt.stopPropagation();
    this.classList.remove('active');
    this.areaDetailsPanes.forEach(p => p.classList.remove('active'));
  }
}

class AreaDetails extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.tab');
    this.tabContents = this.querySelectorAll('.tab-content');

    this.tabs.forEach(t => t.addEventListener('click', this.switchTab.bind(this)));

    this.setHeight();
  }

  setHeight() {
    this.style.position = 'fixed';
    this.style.visibility = 'hidden';
    this.style.display = 'block';

    const floorPlan = document.querySelector('aside.floor-plan');
    const containerHeight = floorPlan.clientHeight;

    const spaceDescription = document.querySelector('.space-description');
    const spaceDescriptionHeight = spaceDescription.clientHeight;

    const tabContainer = this.querySelector('.tabs');
    const tabContainerHeight = tabContainer ? tabContainer.clientHeight : 0;

    const tabContents = this.querySelector('.tab-contents');
    tabContents.style.height = containerHeight - (spaceDescriptionHeight + tabContainerHeight) + 'px';

    this.style.position = '';
    this.style.visibility = '';
    this.style.display = '';
  }

  switchTab(evt) {
    const tabIndex = evt.currentTarget.tabIndex;
    const tabContent = this.querySelector(`.tab-content[tabindex="${tabIndex}"]`);

    if(evt.currentTarget.classList.contains('active'))
      return

    this.tabContents.forEach(tc => tc.classList.remove('active'));
    tabContent.classList.add('active');

    this.tabs.forEach(t => t.classList.remove('active'));
    evt.currentTarget.classList.add('active');
  }
}

if (!customElements.get('space-element'))
  customElements.define('space-element', SpaceElement);

if (!customElements.get('area-element'))
  customElements.define('area-element', Arealement);

if (!customElements.get('area-details'))
  customElements.define('area-details', AreaDetails);